export const NEW_THREAD_BUTTON_UN_MOUNT_TIME = 150

export const AI_CHAT_SUPPORT_ID = 'th'

export const MAX_HISTORY_THREADS_TO_SHOW = 20

export const AI_CHAT_SUPPORT_WEBSOCKET_URL = 'https://echo.websocket.org' //TODO: Update Websocket URL

export const GET_MESSAGES_API_LIMIT = 20
